import { Skeleton } from "../primitives/Skeleton";

export const ResourceCardSkeleton = () => (
  <div className="flex flex-col gap-2.75 p-3.5 rounded-card border border-line-faint">
    <Skeleton className="h-card-thumb rounded-xl" />
    <Skeleton className="h-4.5 w-10/12 rounded-sm" />
    <div className="flex items-center justify-between gap-2 pt-2.5 mt-auto border-t border-line-faint">
      <Skeleton className="h-6 w-20 rounded-pill" />
      <Skeleton className="h-3 w-14 rounded-sm" />
    </div>
  </div>
);

export const ResourceCardGridSkeleton = ({ count = 6 }: { count?: number }) => (
  <div className="flex flex-col gap-2.75">
    <Skeleton className="h-[25px] w-28 rounded-pill" />
    <div className="grid grid-cols-cards gap-card-gap">
      {Array.from({ length: count }, (_, index) => (
        <ResourceCardSkeleton key={index} />
      ))}
    </div>
  </div>
);

export const ResourceRowSkeleton = () => (
  <div className="flex items-center gap-2.75 p-2.5 rounded-card border border-line-faint">
    <Skeleton className="shrink-0 w-8.5 h-9.5 rounded-xs" />
    <div className="flex flex-1 flex-col gap-1.5">
      <Skeleton className="h-3.5 w-10/12 rounded-sm" />
      <Skeleton className="h-3 w-6/12 rounded-sm" />
    </div>
  </div>
);

export const ClassTileSkeleton = ({ compact = false }: { compact?: boolean }) =>
  compact ? (
    <Skeleton className="grow shrink-0 basis-cover-tile-basis max-w-cover-tile-max h-cover-tile-h rounded-tile" />
  ) : (
    <Skeleton className="w-full h-56 desk:h-72 rounded-panel" />
  );

export const SubjectGaugeSkeleton = () => (
  <div className="flex items-center gap-3.5 wide:gap-5 w-full min-h-touch px-4 py-2.5 wide:px-6 wide:py-3 rounded-panel-sm">
    <Skeleton className="shrink-0 w-2 h-11 wide:h-14 rounded-pill" />
    <div className="flex flex-1 flex-col gap-1.5">
      <Skeleton className="h-4 w-8/12 rounded-sm" />
      <Skeleton className="h-3 w-5/12 rounded-sm" />
    </div>
    <Skeleton className="shrink-0 h-4 w-5 rounded-sm" />
  </div>
);

export const CategoryFilterSkeleton = () => (
  <div className="flex items-center gap-2.25">
    <Skeleton className="h-pill w-16 rounded-pill" />
    <Skeleton className="h-pill w-24 rounded-pill" />
    <Skeleton className="h-pill w-20 rounded-pill" />
    <Skeleton className="h-pill w-24 rounded-pill" />
  </div>
);

export const PageSkeleton = ({ compact = false }: { compact?: boolean }) => (
  <div className={`flex w-full flex-col gap-6 ${compact ? "" : "max-w-5xl px-9 py-12"}`}>
    <Skeleton className="h-10 w-72 max-w-full rounded-field" />
    <div className={`grid gap-6 ${compact ? "grid-cols-1" : "grid-cols-1 sm:grid-cols-2 lg:grid-cols-3"}`}>
      {[0, 1, 2].map((index) => (
        <ClassTileSkeleton key={index} />
      ))}
    </div>
  </div>
);
